import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { DescriptorForm } from '../descriptor/descriptor-form';
import { VedraxFormModalComponent } from '../components/vedrax-form-modal/vedrax-form-modal.component';

import { take, map } from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})
export class DialogFormService {

    constructor(private dialog: MatDialog) { }

    open(descriptor: DescriptorForm): Observable<any> {

        const dialogRef = this.dialog.open(VedraxFormModalComponent, {
            width: '600px',
            data: descriptor,
            disableClose: true
        });

        return dialogRef.afterClosed()
            .pipe(
                take(1),
                map(res => res)
            );
    }

    close(){
        this.dialog.closeAll();
    }

}